import { Box } from "@mui/material";

export default function StandardView(props: { children: React.ReactNode }) {
	return (
		<Box className="fullwidth-container" display={{ xs: "none", md: "block" }}>
			{props.children}
		</Box>
	);
}
